import { render } from "./SalesNewOperPage.vue?vue&type=template&id=4952b794&ts=true"
import script from "./SalesNewOperPage.vue?vue&type=script&lang=ts"
export * from "./SalesNewOperPage.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__